import {Alert, Button, DatePicker, Form, Input, Select} from 'antd'
import React, {useState} from 'react'
import validationApi, {TransactionType} from './ValidationApi';

const FormItem = Form.Item
const Option = Select.Option
const validated = 'Transaction was validated'
const validationFailed = 'Wrong transaction hash'
const dateFormat = 'YYYY-MM-DD HH:mm:ss'

export const Validation: React.FC = () => {

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string>()
    const [form] = Form.useForm()
    const [transactionType, setTransactionType] = useState<TransactionType>(TransactionType.BidRequest);
    const [match, setMatch] = useState(false)
    const [validation, setValidation] = useState<string>()
    const [transaction, setTransaction] = useState<any>()
    const [rawTransaction, setRawTransaction] = useState<any>()
    const [prettyView, setPrettyView] = useState<boolean>(true)
    const [jsonResponse, setJsonResponse] = useState<boolean>(true)

    const getTransaction = async () => {
        clearTransaction()
        form.validateFields().then((values) => {
            let responseValue
            setLoading(true);
            validationApi
                .getTransaction(
                    {...values, dateTime: form.getFieldValue('dateTime').format(dateFormat)}
                )
                .then(response => {
                    responseValue = response.value;
                    console.log(responseValue)
                    if (responseValue === 'validation.limit.reached') {
                        setError('Validation request limit reached');
                        return
                    }
                    if (jsonResponse) {
                        setRawTransaction(responseValue);
                        setTransaction(JSON.parse(responseValue));
                    } else {
                        setTransaction(responseValue);
                    }
                })
                .catch(() => {
                    if (responseValue) {
                        setRawTransaction(responseValue);
                        setTransaction(responseValue);
                        setError('Failed to parse response');
                    } else {
                        setError('Failed to get transaction for this data');
                    }
                }).finally(() => setLoading(false))
        })
    }

    const matchTransaction = async () => {
        setValidation('')
        setError('')
        form.validateFields().then((values) => {
            setLoading(true)
            validationApi
                .matchTransaction({...values, dateTime: form.getFieldValue('dateTime').format(dateFormat)})
                .then(response => {
                    setValidation(response.toString())
                })
                .catch(() => {
                    setError('Failed to match transaction for this data')
                }).finally(() => setLoading(false))
        })
    }

    const handleTypeChange = (value) => {
        clearTransaction()
        onChangeForm()
        setTransactionType(value)
        let reqResp = [TransactionType.BidRequest, TransactionType.BidResponse].includes(value);
        setJsonResponse(reqResp)
        reqResp && form.resetFields(['id2'])
    };

    const handleHash = (value) => {
        setMatch(!value.isEmpty)
    };

    const togglePrettyView = () => {
        setPrettyView(!prettyView)
    };

    const clearTransaction = () => {
        setRawTransaction('')
        setTransaction('')
        setError('')
    };

    const onChangeForm = () => {
        setValidation('')
        setError('')
    };

    return (
        <div>
            <Form
                style={{
                    maxWidth: '1000px'
                }}
                form={form}
                labelCol={{span: 3}}
                wrapperCol={{span: 21}}
                onChange={onChangeForm}
            >
                <FormItem
                    name="dateTime"
                    rules={[
                        {
                            required: true,
                            message: 'Please choose date'
                        }
                    ]}
                    label="Date"
                >
                    <DatePicker format="YYYY-MM-DD HH:mm:ss" showTime={{format: 'HH:mm:ss'}}/>
                </FormItem>
                <FormItem
                    name="transactionType"
                    initialValue={transactionType}
                    rules={[{required: true, message: 'Please select Transaction Type'}]}
                    label="Type"
                >
                    <Select
                        onChange={handleTypeChange}
                        placeholder="Select Transaction type">
                        {Object.values(TransactionType).map(role => <Option key={role} value={role}>{role}</Option>)}
                    </Select>
                </FormItem>

                <FormItem
                    name="id1"
                    label="ID1"
                    rules={[{required: true, message: 'Please input ID1'}]}
                >
                    <Input onChange={clearTransaction}/>
                </FormItem>

                <FormItem
                    name="id2"
                    label="ID2"
                    rules={[{
                        required: !jsonResponse,
                        message: 'Please input ID2'
                    }]}
                >
                    <Input onChange={clearTransaction} disabled={jsonResponse}/>
                </FormItem>

                <FormItem
                    name="hash"
                    label="HASH"
                >
                    <Input onChange={handleHash}/>
                </FormItem>

                <FormItem
                    wrapperCol={{
                        offset: 5, span: 19
                    }}>
                    <Button style={{
                        width: '33%',
                        margin: '0 0 1% 0'
                    }} type="primary" htmlType="button" onClick={getTransaction} loading={loading}>Get
                        transaction</Button>
                    <Button style={{
                        width: '33%',
                        margin: '0 0 0 1%'
                    }} type="primary" htmlType="button" disabled={!match} onClick={matchTransaction} loading={loading}>Match
                        transaction</Button>
                </FormItem>

            </Form>
            {loading}
            {error && <div><Alert message={error} type="error"/><br/></div>}
            {validation === 'true' && <div><Alert message={validated} type="success"/><br/></div>}
            {validation === 'false' && <div><Alert message={validationFailed} type="error"/><br/></div>}

            {transaction && <div>
                <Button style={{
                    width: '33%',
                    margin: '0 0 1% 0'
                }}
                        hidden={!jsonResponse}
                        type="default" htmlType="button" onClick={togglePrettyView}>Raw / Pretty View</Button>
                <pre>{jsonResponse ? prettyView ? JSON.stringify(transaction, null, 4) : rawTransaction : transaction}</pre>
            </div>}
        </div>
    )
}
